import { Injectable, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { AdItem } from '../models/ad-item';
import { NotifierMessage } from '../models/notifier-message';

@Injectable()
export class SharedInfo {


    get localAPIurl(): string {
        return environment.localAPIurl;
    }

    get loginUrl(): string {
        return environment.loginUrl;
    }
    
    get serviceUrl(): string {
        return environment.serviceUrl;
    }

    get authUrl(): string {
        return environment.authUrl;
    }

    get signUrl(): string {
        return environment.signUrl;
    }


    @Output() public onSetComponent = new EventEmitter<AdItem<any>>();
    @Output() public onChangePopUpTitle = new EventEmitter<string>();

    public onNotifierError = new EventEmitter<NotifierMessage>();

    
    public AppConfig: any;



    constructor() {


        var stConfig = localStorage.getItem('AppConfig');
        if (stConfig) {
            this.AppConfig = JSON.parse(stConfig);
        }
        else {
            this.AppConfig = {
                brand: 'Dot-Net ERP',
                layoutBoxed: false,               // true, false
                navCollapsed: true,              // true, false
                navBehind: false,                 // true, false
                fixedHeader: true,                // true, false
                sidebarWidth: 'small',           // small, middle, large
                theme: 'light',                   // light, gray, dark
                colorOption: '21',                // 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
                AutoCloseMobileNav: true,         // true, false. Automatically close sidenav on route change (Mobile only)
                productLink: 'https://www.dotnetsistemas.com.br',
                offLineMode: false
            };

            localStorage.setItem('AppConfig', JSON.stringify(this.AppConfig));
        }



    }

    saveConfig(){
        localStorage.setItem('AppConfig', JSON.stringify(this.AppConfig));
    }
}

